import { ProdutoComposicaoKitStruct } from './produto-composicao-kit.struct';
import { ProdutoListaPrecoVigenteStruct } from './produto-lista-preco-vigente.struct';
import { TagListItem } from './tag-list-item.struct';

export class ProdutoListStruct {
  idProduto: number;
  descricao: string;
  codigoSku?: string;
  gtinEan?: string;
  unidade?: string;
  idUnidadeMedida?: number | null;

  // Unidade que nao fraciona aceita so inteiro na quantidade. Vem do cadastro da unidade.
  isUnidadeMedidaFracionada?: boolean;
  // Controle de múltiplo do produto — usado pela composição do kit para validar a quantidade.
  isControlaMultiplo?: boolean;
  idUnidadeMultiplo?: number | null;
  fatorMultiplo?: number | null;
  unidadeMultiplo?: string;
  ncm?: string;
  cest?: string;

  /** Origem da mercadoria (id em origem_mercadoria, db_motor_fiscal). Null = não informada. */
  idOrigemMercadoria?: number | null;
  /** Tipo de item do SPED (id em tipo_item_sped, db_motor_fiscal). Null = não informado. */
  idTipoItemSped?: number | null;
  /** Fator de conversão da unidade comercial para a tributável. */
  fatorConversao?: number | null;
  /** Quantidade tributada na monofasia. */
  qtdTributadaMonofasia?: number | null;
  /** Quantidade tributada sujeita à retenção na monofasia. */
  qtdTributadaRetencaoMonofasia?: number | null;
  /** Código ANP do combustível (id_anp_empresa). Null = não é combustível. */
  idAnpEmpresa?: number | null;

  /** Preço da lista PADRÃO. Continua vindo para todos os chamadores, como sempre veio. */
  preco?: number;

  /**
   * As listas de preço vigentes que alcançam o produto. Só vem com `incluirListasPreco=true`;
   * para os demais chamadores do lookup fica vazia.
   */
  listasPreco?: ProdutoListaPrecoVigenteStruct[];
  pesoBrutoKg?: number;
  pesoLiquidoKg?: number;
  custo?: number;
  custoMedio?: number;
  marca?: string;
  codFornecedor?: string;
  saldoFisico?: number;
  saldoDisponivel?: number;
  tags?: TagListItem[];
  isVariacao: boolean;
  qtdVariacoes: number;
  isKit: boolean;

  /** Kit de PREÇO FIXO (§6.9): o preço do kit é rateado entre os componentes. Vem sempre. */
  isPrecoFixoKit?: boolean;

  /**
   * Componentes do kit, cada um com o seu `produtoListStruct` (e `listasPreco` quando pedido).
   * Só vem com `incluirComposicaoKit=true`; para os demais chamadores fica vazia.
   */
  composicaoKit?: ProdutoComposicaoKitStruct[];
  isFabricado: boolean;
  isControlaLotes: boolean;
  isControlaSeries: boolean;
  idTipoProduto: number;
  tipoProduto?: string;
  variacoes: ProdutoListStruct[] = [];
}
